import { api } from "@services/api";
import { ensureFreshToken } from "@services/http";
import {
  type SasTokenRequestPayload,
  type SasTokenResponse,
  type UserResponse,
} from "@services/user/types";

export async function getUser() {
  const token = await ensureFreshToken();
  if (!token) throw new Error("Not authenticated");
  return api.get<UserResponse>("bff-user", "api/user");
}

export async function getSasToken(payload: SasTokenRequestPayload, transactionId?: string) {
  const token = await ensureFreshToken();
  if (!token) throw new Error("Not authenticated");
  return api.post<SasTokenResponse>(
    "bff-user",
    `api/user/sas-token`,
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
}

export async function getPublicSasToken(payload: SasTokenRequestPayload, transactionId?: string) {
  return api.post<SasTokenResponse>(
    "bff-user",
    "public/api/user/sas-token",
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
}
